// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import moment from 'moment';
// COMPONENTS
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { Link, useParams } from 'react-router-dom';
import { Form, Spinner, Modal } from 'react-bootstrap';
import CustomBlock from '../../../components/CustomBlock';
import MUIDataTable from 'mui-datatables';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import Chart from 'react-google-charts';
import { ModalProgressBar } from '../../../../_metronic/_partials/controls';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import BlockUi from 'react-block-ui';
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import Button from '../../../components/Button';
import Agenda from '../../../components/Agenda';
import * as confirmModal from '../../../../redux/confirmModalRedux';
import BottomSheet from '../../../components/BottomSheet';
import JobScheduleDetailBlock from './_partials/JobScheduleDetailBlock';
import JobScheduleInfoBlock from './_partials/JobScheduleInfoBlock';
// SERVICES AND HELPERS
import * as quickBookBillsAndChecksService from '../../../../services/service/quickBookBillsAndChecksService';
import * as jobScheduleService from '../../../../services/service/jobScheduleService';
import * as jobTimeSheetService from '../../../../services/service/jobTimeSheetService';
//STYLES AND ASSETS
import 'react-block-ui/style.css';

const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
  getDay,
  locales,
});

const defaultFilters = {
  start: '01/01/' + new Date().getFullYear(),
  end: moment().format('L'),
  jobId: null,
};

const DnDCalendar = withDragAndDrop(Calendar);

const JobSchedulePage = (props) => {
  const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, auth, jobInfo } = props;
  const { jobId } = useParams();
  const [showScheduleBottomSheet, setShowScheduleBottomSheet] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [filters, setFilters] = useState({ ...defaultFilters, jobId: jobId });
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState(null);
  const [financialData, setFinancialData] = useState([]);
  const [isEditable, setIsEditable] = useState(true);
  const [quickBooksData, setQuickBooksData] = useState([]);
  const [isAuthorizedToEdit, setIsAuthorizedToEdit] = useState([auth.isAdmin, auth.isProjectManager].includes(true));

  useEffect(() => {
    fetchJobSchedules();
    getJobFinanical();
  }, []);

  useEffect(() => {
    if (jobInfo.projectNumber) {
      var myRegexp = new RegExp('-([^-]+)-');
      var match = myRegexp.exec(jobInfo.projectNumber);
      if (['0001', '0002', '0003'].includes(match[1]) && !auth.isAdmin) {
        setIsEditable(false);
      }
      if (auth && auth.user && Object.keys(auth.user).length > 0 && (auth.user.username === 'admin' || auth.user.username === 'Chip')) {
        fetchQuickBooksData(jobInfo.projectNumber);
      }
    }
  }, [jobInfo]);

  const fetchQuickBooksData = (projNum) => {
    quickBookBillsAndChecksService
      .getQuickBooksData(projNum)
      .then((res) => {
        setQuickBooksData(res);
      })
      .catch((err) => {
        console.log('error getting quickbooks data', err);
      });
  };

  const getJobFinanical = () => {
    jobTimeSheetService
      .getJobFinancial(filters)
      .then((res) => {
        const isAdmin = auth && auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip');
        let tempArr = [['Projects - ' + filters.start + ' to ' + filters.end, 'Revenue', 'Target', 'Actual']];

        if (isAdmin) {
          tempArr[0].push('Distributed Admin');
        }

        const dataRow = [res.name, res.revenue, res.target, res.actual];

        if (isAdmin) {
          dataRow.push(res.distributedAdminCosts);
        }

        tempArr.push(dataRow);
        setFinancialData(tempArr);
      })
      .catch((ex) => {})
      .finally(() => {});
  };

  const fetchJobSchedules = () => {
    setLoading(true);
    jobScheduleService.getJobSchedules(jobId).then((res) => {
      setSchedule(
        res.map((x) => {
          return {
            ...x,
            start: new Date(x.start),
            end: new Date(x.end),
            description: `${x.name}: ${x.additionalNotes ? x.additionalNotes : 'N/A'}`,
            imageUrl: x.imageUrl,
          };
        }),
      );
      setLoading(false);
    });
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const dropSchedule = (e, scheduleId) => {
    if (!isEditable && !isAuthorizedToEdit) {
      return;
    }
    setLoading(true);
    jobScheduleService
      .moveSchedule({
        id: e.event.id,
        jobTeamMemberIds: [e.event.userId],
        overRideScheduleIds: scheduleId ? [scheduleId] : [],
        scheduleDates: [
          {
            startDate: moment(e.start).format('MM/DD/YYYY hh:mm a'),
            endDate: moment(e.end).format('MM/DD/YYYY hh:mm a'),
          },
        ],
        skipScheduleIds: [],
      })
      .then((res) => {
        if (res.success) {
          fetchJobSchedules();
          showAlert({ message: res.message, variant: 'success' });
          hideConfirmModal();
        } else {
          showConfirmModal({
            title: 'Schedule Conflict',
            text: `
                        <p class="mb-3">
                            Are you sure you want to transfer this user to a new schedule?
                        </p>
                        <p class="info">
                            This user is already scheduled in <span>${res.jobSchedules[0].projectNumber}</span> <span>#${res.jobSchedules[0].jobName}</span> at <span>${res.jobSchedules[0].location}</span> from <span>${res.jobSchedules[0].start}</span> until <span>${res.jobSchedules[0].end}</span>
                        </p>
                    `,
            rightBtnText: 'Confirm',
            closeBtnAction: () => setLoading(false),
            btnAction: () => dropSchedule(e, res.jobSchedules[0].id),
          });
        }
      })
      .catch((ex) => {
        showAlert({ message: ex.message, variant: 'error' });
        setLoading(false);
      });
  };

  const quickBooksBillAndChecksColumn = [
    {
      name: 'projectNumber',
      label: 'Project Number',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'primary',
          'data-aes-label': 'Project Number',
        }),
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'secondary-one',
          'data-aes-label': 'Amount',
        }),
      },
    },
    {
      name: 'category',
      label: 'Category',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'secondary-two',
          'data-aes-label': 'Category',
        }),
      },
    },
    {
      name: 'description',
      label: 'Description',
      options: {
        filter: false,
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'detail',
          'data-aes-label': 'Description',
        }),
      },
    },
    {
      name: 'transactionDate',
      label: 'Transaction Date',
      options: {
        filter: false,
        sort: true,
        print: false,
        download: true,
        setCellProps: () => ({
          'data-aes-field': 'detail-one',
          'data-aes-label': 'Transaction Date',
        }),
        customBodyRenderLite: (dataIndex) => (
          <CustomBlock className='content-container--actions flex-start pl-0 mt-0'>
            <p>
              {quickBooksData[dataIndex].transactionDate ? moment(quickBooksData[dataIndex].transactionDate).format('MM/DD/YYYY A') : '-'}
            </p>
          </CustomBlock>
        ),
      },
    },
    {
      name: 'transactionType',
      label: 'Transaction Type',
      options: {
        filter: true,
        filterType: 'multiselect',
        sort: true,
        setCellProps: () => ({
          'data-aes-field': 'detail-two',
          'data-aes-label': 'Transaction Type',
        }),
      },
    },
  ];

  return (
    <>
      <Modal centered size='xs' show={isModalOpen} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Filter Financial Chart</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='form'>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>Start Date</label>
              <div className='col-lg-9 col-xl-9'>
                <div className='input-group input-group-lg input-group-solid'>
                  <Flatpickr
                    placeholder='MM/DD/YYYY'
                    options={{
                      enableTime: false,
                      dateFormat: 'm/d/Y',
                      static: true,
                    }}
                    value={filters.start}
                    onChange={(date) => {
                      setFilters({ ...filters, start: moment(date[0]).format('MM/DD/YYYY') });
                    }}
                    className='form-control form-control-lg form-control-solid'
                  />
                </div>
              </div>
            </div>
            <div className='form-group row'>
              <label className='col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600'>End Date</label>
              <div className='col-lg-9 col-xl-9'>
                <div className='input-group input-group-lg input-group-solid'>
                  <Flatpickr
                    placeholder='MM/DD/YYYY'
                    options={{
                      enableTime: false,
                      dateFormat: 'm/d/Y',
                      static: true,
                    }}
                    value={filters.end}
                    onChange={(date) => {
                      setFilters({ ...filters, end: moment(date[0]).format('MM/DD/YYYY') });
                    }}
                    className='form-control form-control-lg form-control-solid'
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button text={'Close'} className='secondary--bg mr-0' size='xxs' onClick={handleModalClose} />
          <Button
            text={'Filter'}
            className='primary--bg mr-0'
            size='xxs'
            onClick={() => {
              getJobFinanical();
              handleModalClose();
            }}
          />
        </Modal.Footer>
      </Modal>
      <div className='col-lg-12 col-xxl-12 mb-10 px-0'>
        <JobScheduleInfoBlock
          showAlert={showAlert}
          scheduleInfo={scheduleInfo}
          setScheduleInfo={setScheduleInfo}
          showConfirmModal={showConfirmModal}
          hideConfirmModal={hideConfirmModal}
          fetchJobSchedules={fetchJobSchedules}
          setProcessing={setProcessing}
          fromDashboard={!isEditable && !isAuthorizedToEdit}
        />
        <div className='card card-custom card-stretch gutter-b'>
          {loading && <ModalProgressBar />}
          <div className='card-header py-3 mb-10'>
            <div className='card-title align-items-start flex-column'>
              <h3 className='card-label font-weight-bolder text-dark'>Job Schedule</h3>
              <span className='text-muted font-weight-bold fz-xs mt-1'>Schedule employees for this job</span>
            </div>
            <div className='card-toolbar'>
              {isEditable && isAuthorizedToEdit && (
                <button type='button' className='btn btn-primary mr-2' onClick={() => setShowScheduleBottomSheet(true)}>
                  Schedule
                </button>
              )}
              <Link to='/services/jobs' className='btn btn-secondary'>
                Cancel
              </Link>
            </div>
          </div>
          <BlockUi tag='div' blocking={loading}>
            <div className='container-fluid mb-10'>
              <DnDCalendar
                popup
                localizer={localizer}
                events={schedule}
                startAccessor='start'
                endAccessor='end'
                style={{ height: 500 }}
                onEventDrop={(e) => dropSchedule(e, null)}
                onSelectEvent={(event) => {
                  setScheduleInfo(event);
                }}
                components={{
                  agenda: {
                    event: Agenda,
                  },
                }}
              />
            </div>
          </BlockUi>
        </div>
      </div>
      <div className='col-lg-12 col-xxl-12 mb-10 px-0'>
        <div className='card card-custom card-stretch gutter-b'>
          <div className='card-header py-3 mb-10'>
            <div className='card-title align-items-start flex-column'>
              <h3 className='card-label font-weight-bolder text-dark'>Job Snap Shot</h3>
            </div>
            <Button text='Filter' className='primary--bg mr-0' size='xxs' onClick={() => setIsModalOpen(true)} />
          </div>
          <div className='container mb-10'>
            <Chart
              width={'100%'}
              height={'300px'}
              chartType='Bar'
              loader={<div>Loading Chart</div>}
              data={financialData}
              formatters={[
                {
                  type: 'NumberFormat',
                  column: 1,
                  options: {
                    prefix: '$',
                    pattern: 'decimal',
                    negativeColor: 'red',
                    negativeParens: true,
                  },
                },
                {
                  type: 'NumberFormat',
                  column: 2,
                  options: {
                    prefix: '$',
                    pattern: 'decimal',
                    negativeColor: 'red',
                    negativeParens: true,
                  },
                },
                {
                  type: 'NumberFormat',
                  column: 3,
                  options: {
                    prefix: '$',
                    pattern: 'decimal',
                    negativeColor: 'red',
                    negativeParens: true,
                  },
                },
                ...(auth && auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip')
                  ? [
                      {
                        type: 'NumberFormat',
                        column: 4,
                        options: {
                          prefix: '$',
                          pattern: 'decimal',
                          negativeColor: 'red',
                          negativeParens: true,
                        },
                      },
                    ]
                  : []),
              ]}
              options={{
                chart: {
                  title: 'Snap Shot',
                  subtitle: '',
                },
                colors:
                  auth && auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip')
                    ? ['#0f9d58', '#4285f4', '#db4437', '#ff6f61']
                    : ['#0f9d58', '#4285f4', '#db4437'],
              }}
              rootProps={{ 'data-testid': '2' }}
            />
          </div>
        </div>
      </div>
      <BottomSheet title='Schedule Team Members' open={showScheduleBottomSheet} rounded>
        <JobScheduleDetailBlock
          showScheduleBottomSheet={showScheduleBottomSheet}
          setShowScheduleBottomSheet={setShowScheduleBottomSheet}
          jobId={jobId}
          fetchJobSchedules={fetchJobSchedules}
          showAlert={showAlert}
        />
      </BottomSheet>
      {auth && auth.user && Object.keys(auth.user).length > 0 && (auth.user.username === 'admin' || auth.user.username === 'Chip') && (
        <div className='col-lg-12 col-xxl-12 mb-10 px-0'>
          <div className='card card-custom card-stretch gutter-b aes-admin-listing-page aes-admin-listing-page--job-schedule-quickbooks'>
            <div className='card-header py-3 mb-10'>
              <div className='card-title align-items-start flex-column'>
                <h3 className='card-label font-weight-bolder text-dark'>Bills And Checks - {jobInfo.projectNumber}</h3>
              </div>
            </div>
            <div className='aes-admin-listing'>
              <MUIDataTable
                className='aes-admin-listing-surface'
                data={quickBooksData}
                columns={quickBooksBillAndChecksColumn}
                options={{
                  responsive: 'standard',
                  rowsPerPage: 10,
                  rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                  selectableRows: 'none',
                  setTableProps: () => ({
                    className: 'aes-admin-listing-table',
                  }),
                  textLabels: {
                    body: {
                      noMatch: loading ? <Spinner animation='border' size='lg' variant='info' /> : 'Sorry, no matching records found.',
                    },
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  ...alert.actions,
  ...confirmModal.actions,
})(JobSchedulePage);
